export default import.meta.ROLLDOWN_FILE_URL_ct9qoSdYGROEEw_7qipfDQ